import { createFileRoute, redirect } from "@tanstack/react-router";
import { logoutFn } from "#/modules/util.auth/auth.functions";

export const Route = createFileRoute("/$locale/{-$schoolyear}/logout")({
  // Never intent-preload: a preloaded match counts as fresh for preloadStaleTime, so the
  // click that follows a hover would reuse it and skip the loader, leaving the user on /logout.
  preload: false,
  loader: async ({ params }) => {
    await logoutFn();
    throw redirect({
      to: "/$locale/{-$schoolyear}/login",
      params: { locale: params.locale, schoolyear: params.schoolyear },
    });
  },
});
